import { render, staticRenderFns } from "./PhoneButton.vue?vue&type=template&id=18b89d45"
import script from "./PhoneButton.vue?vue&type=script&lang=js"
export * from "./PhoneButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ScPhoneLink: require('/opt/build/repo/node_modules/@evince/site/lib/packages/PhoneLink.vue').default})
